import React from "react";
import { useTranslation } from "react-i18next";

function clampScore(v) {
  const n = parseInt(v, 10);
  if (Number.isNaN(n)) return 0;
  return Math.max(0, Math.min(20, n));
}

const ActualResultCard = ({
  sport, scenario,
  homeScore, awayScore, onHome, onAway,
  overtime, onOvertime,
  advancing, onAdvancing,
  homeColor, awayColor,
  aggregate,
}) => {
  const { t } = useTranslation();
  const isSecondLeg = scenario === "SECOND_LEG";
  // Football overtime is derived from the score (a draw after 90 min / on aggregate),
  // exactly like the real match card — no manual checkbox. Only hockey toggles it
  // explicitly, because its golden-goal score is a win even though regulation was a draw.
  const showOvertimeToggle = sport === "HOCKEY";
  const showAdvancingUi = sport === "FOOTBALL" && scenario !== "STANDARD" && overtime;

  const homeName = t("scoring.team.home");
  const awayName = t("scoring.team.away");

  return (
    <div className="scoring-actual-card">
      <div className="scoring-actual-card__header">
        <span className="scoring-actual-card__check">✓</span>
        <span>{t("scoring.actual.title")}</span>
      </div>

      <div className="scoring-actual-card__body">
        <div className="scoring-actual-row">
          <div className="scoring-actual-row__team">
            <span className="scoring-actual-row__dot" style={{ background: homeColor }} />
            <div>
              <div className="scoring-actual-row__role">{homeName}</div>
            </div>
          </div>
          <input
            type="number"
            className="scoring-actual-row__input"
            value={homeScore}
            onChange={(e) => onHome(clampScore(e.target.value))}
            min="0"
            max="20"
          />
        </div>

        <div className="scoring-actual-row">
          <div className="scoring-actual-row__team">
            <span className="scoring-actual-row__dot" style={{ background: awayColor }} />
            <div>
              <div className="scoring-actual-row__role">{awayName}</div>
            </div>
          </div>
          <input
            type="number"
            className="scoring-actual-row__input"
            value={awayScore}
            onChange={(e) => onAway(clampScore(e.target.value))}
            min="0"
            max="20"
          />
        </div>

        {showOvertimeToggle && (
          <label className="scoring-actual-toggle">
            <input
              type="checkbox"
              checked={overtime}
              onChange={(e) => onOvertime(e.target.checked)}
            />
            <span className="scoring-actual-toggle__slider" />
            <span className="scoring-actual-toggle__label">
              {sport === "FOOTBALL"
                ? t("scoring.overtimeActual.football")
                : t("scoring.overtimeActual.hockey")}
            </span>
          </label>
        )}

        {isSecondLeg && aggregate && (
          <div className={`scoring-aggregate scoring-aggregate--green ${aggregate.draw ? "is-draw" : ""}`}>
            <span className="scoring-aggregate__label">{t("scoring.aggregate.label")}</span>
            <span className="scoring-aggregate__score">{aggregate.home}:{aggregate.away}</span>
            {aggregate.draw && (
              <span className="scoring-aggregate__chip">{t("scoring.aggregate.draw")}</span>
            )}
          </div>
        )}

        {showAdvancingUi && (
          <div className="scoring-advancing scoring-advancing--green">
            <div className="scoring-advancing__label">{t("scoring.advancing")}</div>
            <div className="scoring-advancing__options">
              <label>
                <input
                  type="radio"
                  checked={advancing === "HOME"}
                  onChange={() => onAdvancing("HOME")}
                />
                <span>{homeName}</span>
              </label>
              <label>
                <input
                  type="radio"
                  checked={advancing === "AWAY"}
                  onChange={() => onAdvancing("AWAY")}
                />
                <span>{awayName}</span>
              </label>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default ActualResultCard;
